// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3Wof0","unreadBadge":"styles_unreadBadge__sxKPt","modalContent":"styles_modalContent___I878","modal":"styles_modal__nHEtO"};